import { LoadingOval } from "../../components/loaders/loaders";
import { PRIMARY_COLOR } from "../../utils/constants";

export const PaymentSuccessPage = () => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <LoadingOval color={PRIMARY_COLOR} loaderWidth="20" loaderHeight="20" />
    </div>
  );
};
